import { DefaultService } from '@/services/DefaultService';

export default class EstadoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(estado) {
        return this._http.post(`${this._env}/general/state`, estado, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id) {
        return this._http.get(`${this._env}/general/state/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAll(page = 0, limit = 50, ...param) {
        return this._http.get(encodeURI(`${this._env}/general/state.json?page=${page}&limit=${limit}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

}